import React from "react";

const FALLBACK_SEAT_PLAN_IMAGE = "/assets/seatmap_sample.png";

const SeatPlanImageModal = ({ open = false, onClose, title = "", imageUrl = "" }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black/80 px-4 py-6 flex items-center justify-center">
      <div className="w-full max-w-5xl rounded-3xl bg-[#111] border border-white/10 shadow-2xl overflow-hidden">
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] text-white/50">Seat Map</p>
            <h2 className="text-xl md:text-2xl font-black uppercase">{title}</h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-3xl leading-none text-white/80 hover:text-white"
          >
            ×
          </button>
        </div>

        <div className="p-4 md:p-6 bg-[#0a0a0a]">
          <div className="rounded-2xl bg-white p-3 md:p-4 max-h-[78vh] overflow-auto">
            <img
              src={imageUrl || FALLBACK_SEAT_PLAN_IMAGE}
              alt="Seat Map Large View"
              className="w-full h-auto object-contain rounded-lg"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SeatPlanImageModal;
